const convertToRiR = (value, skipConversion = false) => {
  if (skipConversion || !value || value === "") return value;
  if (value === "AMRAP") return "AMRAP";
  return +(10 - value).toFixed(1);
};

export default convertToRiR;
